export function parseAsinList(value: string): { valid: string[]; invalid: string[] } {
  const tokens = [
    ...new Set(
      value
        .split(/[\s,;]+/)
        .map((token) => token.trim().toUpperCase())
        .filter(Boolean),
    ),
  ];
  return {
    valid: tokens.filter((token) => /^[A-Z0-9]{10}$/.test(token)),
    invalid: tokens.filter((token) => !/^[A-Z0-9]{10}$/.test(token)),
  };
}

export const MAX_PRODUCT_LINE_ASINS = 500;
